import styled from 'styled-components';

export const Header = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  flex-direction: center;
  margin-top: 3rem;
`;
export const TextArea = styled.div`
  display: flex;
  color: white;
`;

export const Subtitle = styled.div`
  display: grid;
  justify-content: flex-end;
  margin-top: -0.6rem;
`;

export const Line = styled.hr`
  margin-top: -3rem;
  color: white;
`;

export const Img = styled.img`
  heigth: 3rem;
  width: 40rem;
`;

export const ToolBar = styled.div`

`;

export const TitleArea = styled.div`

`;